module.exports = __webpack_public_path__ + "img/home.332a91d9.webp";